import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import FullscreenModal from "../modal/fullScreenModal";



export default function Carousel({imageArray, autoplay=false, isVertical=false}){


    const [currIndex, setCurrIndex] = useState(0);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isAutoplayActive, setIsAutoplayActive] = useState(autoplay);
    const [refreshFlag, setRefreshFlag] = useState(0);


    const openModal = () => {
        setModalIsOpen(true);
        setIsAutoplayActive(false);
    }

    const closeModal = () => {
        setModalIsOpen(false);
        setIsAutoplayActive(true);
    }

    const onClickPrev = () => {

        if(currIndex - 1 >= 0){
            const newIndex = currIndex - 1;
            setCurrIndex(newIndex);

            const currentFlag = refreshFlag;
            setRefreshFlag(!currentFlag);


        }

    }
    
    const onClickNext = () => {

        if(currIndex + 1 < imageArray.length){
            const newIndex = currIndex + 1;
            setCurrIndex(newIndex);

            const currentFlag = refreshFlag;
            setRefreshFlag(!currentFlag);
        }

    }


    const verticalDivClass = `
        h-[300px]

        sm:h-[350px]

        md:h-[600px]

        lg:h-[700px]

        xl:h-[700px]
    `;


    const horizontalDivClass= `
        w-[400px]

        sm:min-w-[450px]

        md:min-w-[700px]

        lg:min-w-[800px]

        xl:min-w-[900px]
    `;



    const generateImages = () => {

        let displayArray = [];

        for(let i = 0; i < imageArray.length; i++){

            displayArray.push(
                <div
                    className={
                        (isVertical?verticalDivClass:horizontalDivClass) + 
                        `
                        px-10

                        transition-all
                        duration-700
                        ease-in-out

                        absolute
                    `}
                    style={{
                        top: "50%",
                        left: "50%",
                        // transform: `translate(${-50 + (100 * (i - currIndex))}%, -${50}%) scale(${(currIndex == i)?1:0.8})`,
                        transform: `translate(${-50 + (100 * (i - currIndex))}%, -${50}%)`,
                    }}
                >
                    <img
                        src={imageArray[i]}
                        alt={"Image " + i}
                        className="
                            object-cover
                            object-center
                            h-full
                            w-full
                            cursor-pointer
                        "
                        onClick={openModal}
                    />
                </div>
            );
        }

        return displayArray;

    }


    useEffect(() => {

        if(!isAutoplayActive) return;

        const interval = setInterval(() => {
            setCurrIndex((prevIndex) => (prevIndex + 1) % imageArray.length);
        }, 3500);

        return () => clearInterval(interval);

    }, [refreshFlag, isAutoplayActive, imageArray.length]);


    return(
        <>

            <div
                className="
                    h-full
                    w-full
                    overflow-hidden
                    relative
                    z-10
                    select-none
                "
            >
                

                
                <div
                    className="
                        absolute
                        h-full
                        flex
                        justify-between
                        items-center
                        px-[5%]
                        left-0
                        z-20
                    "
                >
                    <div
                        className="
                            flex
                            justify-center
                            items-center
                            bg-white
                            rounded-full
                            p-2
                            shadow-md
                            cursor-pointer

                            transition-all
                            ease-in-out
                            duration-200
                        "
                        style={{
                            opacity: (currIndex === 0)?0:100,
                        }}
                        onClick={onClickPrev}
                    >
                        <ChevronLeft />
                    </div>


                </div>


                <div
                    className="
                        absolute
                        h-full
                        flex
                        justify-between
                        items-center
                        px-[5%]
                        right-0
                        z-20
                    "
                >
                    <div
                        className="
                            flex
                            justify-center
                            items-center
                            bg-white
                            rounded-full
                            p-2
                            shadow-md
                            cursor-pointer

                            transition-all
                            ease-in-out
                            duration-200
                        "
                        style={{
                            opacity: (currIndex === imageArray.length - 1)?0:100,
                        }}
                        onClick={onClickNext}
                    >
                        <ChevronRight />
                    </div>


                </div>

                {
                    generateImages()
                }

            </div>


            <FullscreenModal
                onCloseModal={closeModal}
                isOpen={modalIsOpen}
            >
                <div
                    className="
                        h-full
                        w-full
                    "
                >
                    <img
                        priority={true}
                        loading="eager"
                        src={imageArray[currIndex]}
                        alt={"Image " + currIndex}
                        className="
                            object-contain
                            object-center
                            h-full
                            w-full
                        "
                    />
                </div>
            </FullscreenModal>

        </>
    );

}